import { useCallback, useEffect, useState } from 'react';
import type { CardioGoals } from '@/types/Workout';
import { DEFAULT_GOALS } from '@/types/Workout';

const STORAGE_KEY = 'ef_goals';
const HOME_SYNC_KEY = 'ef_goal_cardio';

function loadGoals(): CardioGoals {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_GOALS };
    const parsed = JSON.parse(raw) as Partial<CardioGoals>;
    return { ...DEFAULT_GOALS, ...parsed };
  } catch {
    return { ...DEFAULT_GOALS };
  }
}

export function useCardioGoals(currentSessions: number) {
  const [goals, setGoals] = useState<CardioGoals>(() => loadGoals());

  // Каждый раз когда меняется (число тренировок | таргет) — пишем в общий store,
  // чтобы home page показал актуальный прогресс.
  useEffect(() => {
    localStorage.setItem(
      HOME_SYNC_KEY,
      JSON.stringify({
        target: goals.sessions,
        current: currentSessions,
        unit: 'sessions',
        label: 'Sessions this month',
      }),
    );
  }, [goals.sessions, currentSessions]);

  const setSessionsTarget = useCallback((value: number) => {
    setGoals((g) => {
      const next = { ...g, sessions: Math.round(value) };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const setDistanceTarget = useCallback((value: number) => {
    setGoals((g) => {
      const next = { ...g, distanceKm: value };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return { goals, setSessionsTarget, setDistanceTarget };
}
